import { Injectable, Inject, forwardRef } from '@nestjs/common';
import { Repository, Raw, getConnection, getRepository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Logs } from './logs.entity';
import { LogsDto } from '@gtpl/shared-models/gtpl';
import { LogsResponseModel} from '@gtpl/shared-models/gtpl';
@Injectable()
export class LogsService {
  async getLogs(): Promise<LogsResponseModel> {
    try{
      
      const logsDtos: LogsDto[] = [];
      // let logs_data= getRepository('Logs').createQueryBuilder("Logs").select(["concat(':',operation,table_name,logs.display_value) as message"])
      // .leftJoin("user","user","user.id=Logs.created_user")
      // .where('date(created_at) >= ( CURDATE() - INTERVAL 6 DAY ) ')
      // .execute();
      // logsDtos.push(logs_data);
      const logs_data=await getConnection() .createQueryBuilder() 
      .select(["concat(user.username,' : ',operation,'  ',table_name,'   ',Logs.display_value) as message,CONCAT(DATE_FORMAT(created_at,'%Y-%m-%d'),'::',DATE_FORMAT(created_at,'%H:%i:%s')) as timestamp"]) 
      .from(Logs, "Logs")
      .leftJoin("user","user","user.id=Logs.created_user")
      .where('date(created_at) >= ( CURDATE() - INTERVAL 7 DAY ) ') 
      // .where("user.id = :id", { id: 1 }) .getOne();
      .orderBy('Logs.log_id','DESC')
      .getRawMany();
      console.log('logs data');      
      console.log(logs_data);
      
      // response.status = true;
      // // response.data = [{message:"1st notification",timestamp:1596119686811},{message:"2nd notification",timestamp:1596119686812},{message:"3rd notification",timestamp:1596119686812}];
      // response.data=logs_data;
      // response.statusCode = 50000;
      // response.internalMessage = 'Logs retrieved successfully';
      // response.intlCode = 11108;
      const response= new LogsResponseModel(true,11108,'Logs retrieved successfully',logs_data);
      return response;
    }catch(error){
      throw new Error('Logs not retrived.');
    }
    
  }
  constructor(@InjectRepository(Logs)private logsRepository: Repository<Logs>) {}
  async createLog(user_id:number,operationName:string,tableName:string,row_id:number,status:boolean,display_value:string): Promise<boolean> {
    console.log(tableName);
    await getConnection()
    .createQueryBuilder()
    .insert()
    .into(Logs)
    .values([
        { createdUser: user_id,tableName:tableName,operation:operationName,rowId:row_id,status:status,displayValue:display_value}
     ])
    .execute();
    return true;
  }
}